import { TableColumn } from "../../types";

export const providerLabelMap = {
  // Location
  aws: "AWS",
  gcp: "GCP",
  azure: "Azure",
  equinix: "Equinix",
  byok: "BYOK",
  oci: "OCI",
  // Cloud account
  ngs: "NGS",
  // Mk8s
  digitalocean: "Digital Ocean",
  ephemeral: "Ephemeral",
  generic: "Generic",
  hetzner: "Hetzner",
  lambdalabs: "Lambdalabs",
  linode: "Linode",
  oblivus: "Oblivus",
  paperspace: "Paperspace",
  triton: "Triton",
};
const providerDefault = { id: "provider", label: "Provider" };
export function ProviderColumn<TData extends { provider: string }>(column: Partial<TableColumn<TData>> = {}) {
  const preset: TableColumn<TData> = {
    ...providerDefault,
    enableResize: false,
    enableHide: true,
    size: 210,
    cell: (p) => {
      const item = p.row.original;
      return <span>{providerLabelMap[item.provider]}</span>;
    },
  };
  return Object.assign(preset, column);
}
